import { User } from '@src/main/modules/user/domain/user.interface';
import { UserRepository } from '@src/main/modules/user/domain/user.repository';
import { CreateUpdateUserRequest } from '@src/main/modules/user/infrastructure/dto/createUpdateUserRequest';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/users';

export const createUserHttpRepository = (tokenProvider: TokenProvider): UserRepository =>
  new UserHttpRepository(tokenProvider);

class UserHttpRepository implements UserRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<User[]> {
    const token = await this.getAuthToken();
    const response = await api.get<User[]>(`${path}/all`, token);
    return response;
  }

  async findById(id: string): Promise<User> {
    const token = await this.getAuthToken();
    const response = await api.get<User>(`${path}/${id}`, token);
    return response;
  }

  async create(user: CreateUpdateUserRequest): Promise<User> {
    const token = await this.getAuthToken();
    const response = await api.post<User>(path, token, user);
    return response;
  }

  async update(id: string, user: CreateUpdateUserRequest): Promise<User> {
    const token = await this.getAuthToken();
    const response = await api.put<User>(`${path}/${id}`, token, user);
    return response;
  }

  async delete(id: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.delete(`${path}/${id}`, token);
  }
}
